'use client';

import { createTheme, ThemeOptions } from '@mui/material/styles';
import responsiveBaseTheme from '@/styles/brands/base';
import deepmerge from '@mui/utils/deepmerge';

const aro = createTheme(
	deepmerge(responsiveBaseTheme, {
		palette: {
			primary: {
				main: 'rgba(84, 86, 90, 1)', //#54565A
			},
			secondary: {
				main: 'rgba(227, 6, 19, 1)', //#E30613
			},
			accent: {
				main: 'rgba(238, 238, 239, 1)', //#EEEEEF
			},
			lightAccent: {
				main: 'rgba(254, 244, 244, 1)', //#FEF4F4
			},
			lightBackground: {
				main: 'rgba(238, 238, 239, 1)', // #EEEEEF
			},
		},
		components: {
			MuiButton: {
				styleOverrides: {
					contained: () => ({
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(207, 5, 17, 1)', //#CF0511
						},
						'&:focus': {
							backgroundColor: 'rgba(161, 4, 13, 1)', //#A1040D
						},
						'&:active': {
							backgroundColor: 'rgba(161, 4, 13, 1)', //#A1040D
						},
					}),
				},
			},
			MuiFab: {
				styleOverrides: {
					root: {
						boxShadow: 'none',
						'&:hover': {
							backgroundColor: 'rgba(207, 5, 17, 1)', //#CF0511
						},
						'&:focus': {
							backgroundColor: 'rgba(161, 4, 13, 1)', //#A1040D
						},
						'&:active': {
							backgroundColor: 'rgba(161, 4, 13, 1)', //#A1040D
						},
					},
				},
			},
		},
	} as ThemeOptions),
);

export default aro;
